import {defineStore} from 'pinia';
import {ModuleVoucherInformationArise} from '../moduleConst';
import {BaseDictionaryStore} from '../baseDictionaryStore';
import ariseVoucherInformationApi from '@/apis/di/ariseVoucherInformationApi';

const ariseVoucherInformationStore = new BaseDictionaryStore(ariseVoucherInformationApi);

export const useAriseVoucherInformationStore = defineStore(ModuleVoucherInformationArise, {
  state: () => ({
    ...ariseVoucherInformationStore.state,
    _config: {
      key: 'voucher_information_arise_id',
      code: 'code_value',
      name: 'name_value',
      table: 'di_voucher_information_arise',
      moduleName: 'Thông tin phát sinh của chứng từ',
      defaultSort: 'code_value',
    },
    moduleName: ModuleVoucherInformationArise,
  }),
  actions: {...ariseVoucherInformationStore.action},
  getters: {...ariseVoucherInformationStore.getters},
});
